import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <span className="px-6 py-2 bg-teal-500/20 border border-teal-400/30 rounded-full text-teal-300 text-sm font-bold tracking-wider backdrop-blur-sm inline-block">
            Contact Us
          </span>
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight">
          まずはお気軽に<br />
          <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
            ご相談ください
          </span>
        </h2>

        <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
          M&A・事業承継に関するご相談は無料です。<br />
          秘密厳守でお話を伺いますので、安心してご連絡ください。
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
          <Link
            to="/contact"
            className="group relative px-12 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-lg font-bold rounded-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-teal-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10 flex items-center">
              お問い合わせフォーム
              <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></div>
          </Link>
          
          <a
            href="tel:03-1234-5678"
            className="group px-12 py-5 bg-white/10 backdrop-blur-md text-white text-lg font-bold rounded-full border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center"
          >
            <i className="ri-phone-line mr-3 text-xl group-hover:rotate-12 transition-transform"></i>
            03-1234-5678
          </a>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-gray-400">
          <div className="flex items-center">
            <i className="ri-time-line text-2xl text-teal-400 mr-3"></i>
            <span className="text-sm">受付時間：平日 9:00〜18:00</span>
          </div>
          <div className="flex items-center">
            <i className="ri-mail-line text-2xl text-teal-400 mr-3"></i>
            <span className="text-sm">info@nextage.jp</span>
          </div>
        </div>
      </div>
    </section>
  );
}
